module.exports = __webpack_public_path__ + "static/media/LidlPro_Bold.adbeed9c.woff2";